// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-content-enter-active,.dropdown-content-leave-active{transition:all .2s}.dropdown-content-enter,.dropdown-content-leave-to{opacity:0;transform:translateY(-5px)}.dropdown-content-wrapper{position:absolute;right:0;padding-top:.5rem;padding-bottom:.5rem;margin-top:.5rem;border-radius:.5rem;width:12rem;background-color:#fff;transform-origin:top right;border:1px solid #e3e7ed}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
